import React from "react";
import { Popup } from "../../../Types";
import { getLanguageFile } from "../../common/GetLanguageFile";

function OpenVideoPopup({
  popup,
  hotspot,
  setOpen,
}: {
  popup: Popup;
  hotspot: boolean;
  setOpen: (bool: boolean) => void;
}) {
  function youtube_parser(url: string | undefined): string | undefined {
    if (url) {
      let regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      let match = url.match(regExp);
      return match && match[7].length === 11 ? match[7] : undefined;
    }
    return;
  }

  return (
    <>
      <button
        id="popup-close"
        style={{ position: "absolute", right: "20px" }}
        onClick={() => setOpen(false)}
      >
        {getLanguageFile("generics.close")}
      </button>

      <h3>{popup.title}</h3>

      {hotspot && (
        <iframe
          style={{}}
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/${youtube_parser(popup.video)}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          frameBorder={0}
        ></iframe>
      )}
    </>
  );
}

export default OpenVideoPopup;
